import { gql } from '@apollo/client';
import disclaimer from '../../../gqlCommon/graphql/fragments/disclaimer';

const modelTrimLevel = {
  GET_MODEL_TRIM_LEVEL: gql`
    ${disclaimer.DISCLAIMER}
    query GetModelTrimLevel(
      $trimCode: TrimCode!
      $filter: Filters
      $financeProductId: FinanceProductId
      $financeInput: FinanceInput
      $financeFormInput: FinanceFormInput
      $postCode: String
      $shouldFetchDisclaimers: Boolean!
      $dataLayer: Boolean!
    ) {
      trim(trimCode: $trimCode) @include(if: $dataLayer) {
        attributes {
          label
        }
      }
      trimLevelModels(filters: $filter, financeInput: $financeInput, postCode: $postCode) {
        financeFormInput @client
        nextFilters {
          trimCode
          bodyStyleCode
          variantCode
          modelCode
          engineCode
          specPackCode
        }
        carConfig(financeProductId: $financeProductId, financeInput: $financeInput, postCode: $postCode) {
          car {
            attributes {
              vehicleDisplayName
              specDescription
            }
            code
            variant {
              attributes {
                name
              }
            }
            standardFeaturesCategories {
              label
              code
            }
            standardFeatures {
              code
              label
              shortDescription
              longDescription
              categoryCode
            }
            keyFeatures {
              id
              shortname
              attributes {
                disclaimer
              }
            }
          }
          prices {
            totalPrice {
              money {
                amount
                currency
              }
              type
            }
          }
          finance(financeFormInput: $financeFormInput) {
            type
            simulation {
              paymentValue {
                currency
                amount
              }
              interestRate
              comparisonRate
              financeProduct
              frequency
            }
            editText
            disclaimers @include(if: $shouldFetchDisclaimers) {
              ...Disclaimer
            }
          }
        }
        model {
          code
          attributes {
            shortname
            fullSpecsUrl
            oemcode
          }
          image {
            url
          }
        }
      }
    }
  `,
};

export default modelTrimLevel;
